"use client"

import React from "react"
import { ProfileIcon } from "components/SVG"
import { loginWithRedirect } from "hooks/utils/loginWithRedirect"
import type { LocaleType } from "lib/apollo/types"
import { useHasMounted } from "utils/wrappers"
import { LinkWithIcon } from "../LinkWithIcon"

type Props = {
  locale: LocaleType
}

export const LoginLink: React.FC<Props> = ({ locale }) => {
  const hasMounted = useHasMounted()
  return (
    <LinkWithIcon
      icon={<ProfileIcon />}
      title="Login"
      href={
        // @TODO: loginWithRedirect cannot be used on the server, so we need to check if the component has mounted before calling it
        // This is a temporary solution until we have a better way to handle this
        !hasMounted
          ? `${locale === "en-US" ? "/us" : ""}/login`
          : `${locale === "en-US" ? "/us" : ""}${loginWithRedirect()}`
      }
    />
  )
}
